import React from 'react';
import { useFramework } from '@/framework';
import { PluginType, type IExportPlugin } from '@/version-types';
import { useTextLayerHotkey } from './use-text-layer-hotkey';

/**
 * 文本图层快捷键：T 键添加默认文本并进入编辑（子逻辑见 `use-text-layer-hotkey.ts`）。
 */
const TextLayerHotkeyView: React.FC = React.memo(() => {
    const framework = useFramework();

    useTextLayerHotkey(framework);

    return null;
});

export const textLayerHotkeyPlugin: IExportPlugin = {
    type: PluginType.SYSTEM,
    sort: 1,
    name: 'text-layer-hotkey',
    render() {
        return <TextLayerHotkeyView />;
    },
};
